document.addEventListener("DOMContentLoaded", function() {
	var showHead = document.getElementById("js-toggle");
	var find = document.getElementsByClassName("js-wrapper")[0];

	function toggleClass(el, className) {
		if (el.classList) {
			el.classList.toggle(className);
		} else {
			var classes = el.className.split(" ");
			var existingIndex = classes.indexOf(className);

			if (existingIndex >= 0) classes.splice(existingIndex, 1);
			else classes.push(className);

			el.className = classes.join(" ");
		}
	}

	showHead.addEventListener("click", function(e) {
		e.preventDefault();
		toggleClass(find, "active");
	});
});



// WEBPACK FOOTER //
// ./src/js/general/find.js